import { Steps } from 'antd'
import { t } from 'i18next'
import type { ReactElement } from 'react'

import { type KpiFormStep, useStepStatus } from '../../../../recoil/view/hooks/kpiForm'

export const KpiFormSteps = ({
  currentStep,
  setCurrentStep,
}: {
  currentStep: KpiFormStep
  setCurrentStep: (value: number) => void
}): ReactElement => {
  const { checkStepEnabled } = useStepStatus()
  return (
    <Steps current={currentStep} direction="horizontal" className="mb-8" size="small" onChange={setCurrentStep}>
      <Steps.Step title={t(`KPI`)} description="" />
      <Steps.Step title={t(`オブジェクト`)} description="" disabled={!checkStepEnabled(1)} />
      <Steps.Step title={t(`条件設定`)} description="" disabled={!checkStepEnabled(2)} />
      <Steps.Step title={t(`詳細設定`)} description="" disabled={!checkStepEnabled(3)} />
    </Steps>
  )
}
